export default __webpack_public_path__ + "static/media/Onboardlogo-white.59a483a2.svg";